import React, { useState } from "react";
import {
    chargeAcPayment,
    chargeVdsPayment,
    chargeVriPayment,
    startVDSFreeTrial,
    startVRIFreeTrial
} from "../../../api/requests";
import GenericButton from "../buttons/GenericButton";
import GenericItem from "../items/GenericItem";
import CardItem from "../items/CardItem";
import SyncLoader from "react-spinners/SyncLoader";
import {PAYMENT_TYPE} from "../../../constants";
import BackButton from "../buttons/BackButton";

export const SelectPaymentSection = ({type, loading, setLoading, payNow, addNewMode,
                              paymentIntentId, handleSavePaymentDataResult, doNotRenew,
                              allPaymentMethods, selectedMethodId, setSelectedMethodId,
                              handleStartFreeTrialResult, isEligibleForFreeTrial, selectedPlan,
                              onBack, setAddNewMode, data, submitBtnText}) => {
    const [submitting, setSubmitting] = useState(false);

    if (addNewMode) {
        return <></>;
    }

    const { expirationDate } = data;

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!submitting || !selectedMethodId) {
            return;
        }

        setLoading(true);

        if (type === PAYMENT_TYPE.VRI) {
            if (isEligibleForFreeTrial) {
                startVRIFreeTrial(selectedPlan.value, selectedMethodId, handleStartFreeTrialResult);
            } else {
                chargeVriPayment(paymentIntentId, selectedMethodId, selectedPlan.value,
                    doNotRenew, handleSavePaymentDataResult);
            }
        } else if (type === PAYMENT_TYPE.VDS) {
            if (isEligibleForFreeTrial) {
                startVDSFreeTrial(selectedPlan.value, selectedMethodId, handleStartFreeTrialResult);
            } else {
                chargeVdsPayment(paymentIntentId, selectedMethodId, selectedPlan.value,
                    doNotRenew, handleSavePaymentDataResult);
            }
        } else {
            chargeAcPayment(paymentIntentId, selectedMethodId, selectedPlan.value,
                doNotRenew, handleSavePaymentDataResult);
        }
    }

    const onAddNewClick = () => {
        setAddNewMode(true);
    };

    const onBackBtnClick = () => {
        if (onBack) {
            onBack();
        }
    }

    const showAddNewCard = allPaymentMethods.length === 0;

    let Footer = <></>;
    if (selectedMethodId) {
        Footer = (
            <div className={"flexSpaceBetween footerMargins"}>
                {
                    onBack && (
                        <BackButton onClick={onBackBtnClick}
                                    hidden={loading}/>
                    )
                }

                {
                    showAddNewCard ? (
                        <GenericButton onClick={onAddNewClick}
                                       hidden={loading}
                                       text={i18n.payments.addNew}/>
                    ) : <div></div>
                }

                <button className={"button-pay"}
                        hidden={loading}
                        onClick={() => {setSubmitting(true)}}>{submitBtnText}</button>
            </div>
        );
    } else {
        Footer = (
            <div className={"flexSpaceBetween footerMargins"}>
                {
                    onBack && (
                        <BackButton onClick={onBackBtnClick}
                                    hidden={loading}/>
                    )
                }

                {
                    showAddNewCard ? (
                        <GenericButton onClick={onAddNewClick}
                                       hidden={loading}
                                       text={i18n.payments.addNew}/>
                    ) : <div></div>
                }

                <GenericItem title={i18n.payments.selectAPaymentMethod}/>
            </div>
        );
    }

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div className={`row`}>
                    <div className={"col-12 credit-card-container"}>
                        {
                            allPaymentMethods?.map((paymentMethod, idx) => {
                                const { paymentMethodId } = paymentMethod;

                                const onClick = (e) => {
                                    setSelectedMethodId(paymentMethodId);
                                }

                                return (
                                    <CardItem paymentMethod={paymentMethod}
                                              planExpirationDate={expirationDate}
                                              isSelected={selectedMethodId === paymentMethodId}
                                              styles={{ margin: '0.5em' }}
                                              onClick={onClick}/>
                                );
                            })
                        }
                    </div>
                </div>

                {Footer}

                {loading && (<div><SyncLoader /></div>)}
            </form>
        </div>
    );
}